export enum OnlineBriefingTemplateEnum {
    ONLINE_BRIEFING_TEMPLATE_BLANK = 'ONLINE_BRIEFING_TEMPLATE_BLANK',
    ONLINE_BRIEFING_TEMPLATE_DEFAULT = 'ONLINE_BRIEFING_TEMPLATE_DEFAULT',
    ONLINE_BRIEFING_TEMPLATE_COMPETITOR = 'ONLINE_BRIEFING_TEMPLATE_COMPETITOR',
    ONLINE_BRIEFING_TEMPLATE_QUARTERLY = 'ONLINE_BRIEFING_TEMPLATE_QUARTERLY',
    ONLINE_BRIEFING_TEMPLATE_MONTHLY = 'ONLINE_BRIEFING_TEMPLATE_MONTHLY'
}
